<template>
  <div>
    <grant-sub-wizard>

      <grant-sub-wizard-tab :before-change="() => validateStep('step1')">
        <page1 ref="step1"></page1>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step2')">
        <page2 ref="step2"></page2>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step3')">
        <page3 ref="step3"></page3>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step4')">
        <page4 ref="step4"></page4>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step5')">
        <page5 ref="step5"></page5>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step6')">
        <page6 ref="step6"></page6>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step7')">
        <page7 ref="step7"></page7>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step8')">
        <page8 ref="step8"></page8>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step9')">
        <page9 ref="step9"></page9>
      </grant-sub-wizard-tab>

      <grant-sub-wizard-tab :before-change="() => validateStep('step10')">
        <page10 ref="step10"></page10>
      </grant-sub-wizard-tab>

    </grant-sub-wizard>
  </div>
</template>

<script>
  import Page1 from './Page1';
  import Page2 from './Page2';
  import Page3 from './Page3';
  import Page4 from './Page4';
  import Page5 from './Page5';
  import Page6 from './Page6';
  import Page7 from './Page7';
  import Page8 from './Page8';
  import Page9 from './Page9';
  import Page10 from './Page10';
  import {GrantSubWizard, GrantSubWizardTab} from '@/components';

  export default {
    components: {
      GrantSubWizard,
      GrantSubWizardTab,
      Page1,
      Page2,
      Page3,
      Page4,
      Page5,
      Page6,
      Page7,
      Page8,
      Page9,
      Page10
    },
    methods: {
      validateStep(ref) {
        return (this.$refs[ref].validate) ? this.$refs[ref].validate() : true;
      }
    }
  }
</script>